import { useContext } from 'react';
import { FeedItemType } from '~/constants/home';
import NextBestActionContext from '~/context/home/NextBestActionContext';

export default function useHasPurchaseInProgress() {
  const {
    actions: { data }
  } = useContext(NextBestActionContext);
  const feedItems = data?.feedItems ?? [];

  return feedItems.some(
    item => item.type === FeedItemType.RETAIL_PURCHASE_IN_PROGRESS
  );
}
